import React, {useState, useEffect, useCallback, Fragment}  from 'react'
import {Tabs} from 'antd';
import ReimburseList from './reimburse-list'

const {TabPane} = Tabs;
export default function ReimburseTabs(props) {
    const [activeKey, setActiveKey] = useState('accountOut');
    const handleTab = (key) => {
        setActiveKey(key);
    };
    return <div className='box-shadow padding-20'>
        <div className='head-title'>实报实销</div>
        <br/>
        <Tabs onChange={handleTab} activeKey={activeKey}>
            <TabPane tab="已出账" key="accountOut">
                <ReimburseList history={props.history} collectStatus="accountOut" activeKey={activeKey}/>
            </TabPane>
            <TabPane tab="已结算" key="complete">
                <ReimburseList history={props.history} collectStatus="complete" activeKey={activeKey}/>
            </TabPane>
            <TabPane tab="全部" key="">
                <ReimburseList history={props.history} collectStatus="" activeKey={activeKey}/>
            </TabPane>
        </Tabs>
    </div>
}